const admin = (state = {}, action) => {
	switch (action.type) {
		case 'ADMIN_USERS_LIST':
		case 'SET_ADMIN_USER_DETAILS':
		case 'SET_ADMIN_ROLES_LIST':
		case 'SET_ADMIN_CREATE_USER':
		case 'SET_ADMIN_MODIFY_USER':
		case 'SET_ADMIN_SEARCH_ATTRIBUTE':
			return { ...state, ...action.data };
		default:
			return state;
	}
};
export default admin;
